export enum OesTaskType {
  MILESTONE = 'MILESTONE'
}
